import { DESTINATION } from "./action";

const initialState = {
  destList: [],
  destCreated: {},
  selectedDest: {},
  destUpdated: {}
};

export default function destReducer(state = initialState, action) {
  switch (action.type) {
    case DESTINATION.getAllDestList.success:
      return {
        ...state,
        destList: action.data,
        destCreated: {},
        destUpdated: {}
      };
    case DESTINATION.create.success:
      return {
        ...state,
        destCreated: action.data
      };
    case DESTINATION.edit.success:
      return {
        ...state,
        selectedDest: action.data
      };
    case DESTINATION.update.success:
      return {
        ...state,
        destUpdated: action.data
      };
    case DESTINATION.delete.success:
      const destId = action.data.id;
      return {
        ...state,
        destList: state.destList.filter(dest => dest.id !== destId)
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/destinations/reducer.js